import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shInitials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return '';
    }

    const names = value.split(' ');
    const initials = names
      .map((name) => name[0])
      .join('')
      .toUpperCase();

    return initials;
  }
}
